import Data from "../../../core/data/Data";
import {urlEncoder} from "../../../core/utils/url";
import {money} from "../../../core/forms/money";

export const TicketsIndex = {
    mixins: [urlEncoder, money],
    data: () => ({
        tickets: new Data({
            url: '/tickets/list',
            prefix: 'list'
        }),
    }),
    computed: {
        events() {
            return this.tickets.content.data.map(ticket => ({...ticket, event_id: this.encode(ticket.id)}));
        },
    },
    methods: {
        async getTicketEvents() {
            await this.tickets.fetch();
        },
        truncateText(text, length){
            return text.length > length ? text.substring(0, length) + '...' : text;
        }
    },
    async mounted() {
        await this.getTicketEvents();
    }
}
